import projectConfig, { PROJECT } from '~/projects/config';
import { ComplianceExperienceId } from '~/services/compliance/experienceId';
import { REGULARITY } from '~/types/product';
import { SUBSCRIPTION_STATUS } from '~/types/subscription';

export enum BUTTON_SUGGESTION {
  RESTORE = 'restore',
  UPGRADE = 'upgrade',
  EXTENSION = 'extension',
  REDEMPTION = 'redemption',
  REDEMPTION_PENDING = 'redemption_pending',
  REDEMPTION_FAILED = 'redemption_failed',
  UNPAUSE = 'unpause',
}

export const getButtonSuggestion = (data: {
  subStatus: SUBSCRIPTION_STATUS;
  regularity: REGULARITY;
  isExtensionInstalled: boolean;
  isStripeUser: boolean;
  complianceExperienceId: ComplianceExperienceId;
}): BUTTON_SUGGESTION | null => {
  const {
    subStatus,
    regularity,
    isExtensionInstalled,
    isStripeUser,
    complianceExperienceId,
  } = data;

  if (!isStripeUser && subStatus === SUBSCRIPTION_STATUS.CANCEL_PENDING) {
    return complianceExperienceId === ComplianceExperienceId.V0
      ? BUTTON_SUGGESTION.RESTORE
      : null;
  }

  if (!isStripeUser && subStatus === SUBSCRIPTION_STATUS.CANCELLED) {
    return BUTTON_SUGGESTION.RESTORE;
  }

  if (!isStripeUser && subStatus === SUBSCRIPTION_STATUS.REDEMPTION) {
    return BUTTON_SUGGESTION.REDEMPTION;
  }

  if (
    !isStripeUser &&
    subStatus === SUBSCRIPTION_STATUS.REDEMPTION_PAYMENT_PENDING
  ) {
    return BUTTON_SUGGESTION.REDEMPTION_PENDING;
  }

  if (
    !isStripeUser &&
    subStatus === SUBSCRIPTION_STATUS.REDEMPTION_PAYMENT_FAILED
  ) {
    return BUTTON_SUGGESTION.REDEMPTION_FAILED;
  }

  if (!isStripeUser && subStatus === SUBSCRIPTION_STATUS.PAUSED) {
    return BUTTON_SUGGESTION.UNPAUSE;
  }

  if (!isStripeUser && regularity !== REGULARITY.YEAR) {
    return BUTTON_SUGGESTION.UPGRADE;
  }

  if (!isExtensionInstalled && projectConfig.project !== PROJECT.SIDEKICKER) {
    return BUTTON_SUGGESTION.EXTENSION;
  }

  return null;
};
